import { InjectionToken } from '@angular/core';
import { ToastPosition, ToastVariant } from '@core/toast/toast.types';

export interface ToastConfig {
    defaultPosition: ToastPosition;
    defaultDuration: number; // ms; 0 = persistent
    defaultVariant: ToastVariant;

}

export const DEFAULT_TOAST_CONFIG: ToastConfig = {
    defaultPosition: 'bottom-right',
    defaultDuration: 2500,
    defaultVariant: 'fill'
};

export const TOAST_CONFIG = new InjectionToken<ToastConfig>('TOAST_CONFIG', {
    factory: () => DEFAULT_TOAST_CONFIG,
});
